import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EmailService } from '../../email/email.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-addemails',
  templateUrl: './addemails.component.html',
  styleUrls: ['./addemails.component.css']
})
export class AddemailsComponent implements OnInit {

  form = new FormGroup({
    // smtp: new FormControl('',[Validators.required]),
    emails:new FormControl('',[Validators.required])
  });
  issubimitted:boolean=false;
  emailsddata:any;
  dropdownSettings:IDropdownSettings={};
  settings = {
    idField: 'id',
    textField: 'from_email',
    typeField: 'type',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: false,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };
  idgroup:number=0;
  edit:any='';
  constructor(@Inject(MAT_DIALOG_DATA) private Fdata: any, private dialogRef: MatDialogRef<AddemailsComponent>,protected data:EmailService) { }
  ngOnInit() {
    console.log("getting form data :::::=>",this.Fdata);
    this.idgroup=this.Fdata.groupid;
    console.log("id group ",this.idgroup);
    this.getSMTPdata();
  }
  close(data:any){

    this.dialogRef.close(data);
  }
  getSMTPdata(){
    this.data.getRecord().subscribe((res:any)=>{
      if(res!=''){
        this.emailsddata=res;
        console.log("getting all data :::",res);
      }
    })
  }

  changeSmtp(e:any){
    console.log(e.target.value);
    let where='smtp_provider='+e.target.value;
    this.getSMTPdata();    
  }

  onSubmit(){
    if(this.form.invalid){
      this.issubimitted=true;
      return 
    }else{
      let action:number=1;
      this.close({formData:this.form.value,data:this.Fdata.data,idgroup:this.idgroup,isaction:action});
    }
  }
  onclose(){
    let action:number=0;
    let data1=[];
    this.close({formData:data1,data:this.Fdata.data,idgroup:this.idgroup,isaction:action});
  }

}
